import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackEvent as trackEventLazy } from '@/lib/analytics-lazy';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize analytics lazily
    initAnalytics();
  }, []);

  useEffect(() => {
    // Track page views on route change
    trackEventLazy('page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

// Re-export lazy analytics functions
export { 
  trackEvent, 
  trackConversion, 
  trackFormSubmit, 
  trackCTAClick, 
  trackServiceInterest 
} from '@/lib/analytics-lazy';

export default GoogleAnalytics;